import React from "react";
import styles from "../styles/HomePage.module.css";

const HomePage = ({ search }) => {
  return (
    <div className={styles.homePage}>
      <section className={styles.top}>
        <div className={styles.pageHeaderLeft}>
          <div className={styles.waldiezLogo}>
            <img
              className={styles.logo}
              alt="Waldiez Logo"
              loading="lazy"
              src="/logo.svg"
            />
            <h1 className={styles.name}>Waldiez</h1>
          </div>
          <p className={styles.headerText}>
            Make AI Agents Collaborate: <br /> Drag, Drop, and Orchestrate with{" "}
            Waldiez
          </p>
          <div className={styles.ctaButtons}>
            <a
              href="https://waldiez.io"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.primaryButton}
            >
              Learn More
            </a>

            <a
              href="https://docs.waldiez.io"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.secondaryButton}
            >
              Documentation
            </a>
          </div>

        </div>
        <div className={styles.pageHeaderRight}>
          <img
            className={styles.flowImage}
            alt="Waldiez flow"
            fetchPriority="high"
            src="/images/waldiez_flow.png"
          />
        </div>
      </section>

      <hr className={styles.divider} />

      <section className={styles.videoSection}>
        <h1>Share your Agentic workflows</h1>
        <div className={styles.videoContainer}>
          <iframe
            className={styles.video}
            width="720"
            height="405"
            src="https://www.youtube.com/embed/mE8rAwC8Hik?si=cLoCTuGemHgFxvmi"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </section>

      <hr className={styles.divider} />

      <section className={styles.featuresSection}>
        <h1>Build your Agentic portfolio</h1>
        <img
          className={styles.userPageImage}
          alt="User's page"
          fetchPriority="high"
          src="/images/user_page.png"
        />
      </section>

      <hr className={styles.divider} />

      <section className={styles.waldiezAgents}>
        <img
          className={styles.agents}
          alt="Agents"
          fetchPriority="high"
          src="/images/waldiez_agents.png"
        />
      </section>
    </div>
  );
};

export default HomePage;
